import { useEffect, useState } from "react";
import { getHighlight } from "../Service/Api";

import SliderModule from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slider = SliderModule.default || SliderModule;

const DUMMY_DATA = [
  {
    title: "News Title",
    description: "News Description",
    date: "DD-MM-YYYY",
    attachments: [],
  },
  {
    title: "News Title",
    description: "News Description",
    date: "DD-MM-YYYY",
    attachments: [],
  },
  {
    title: "News Title",
    description: "News Description",
    date: "DD-MM-YYYY",
    attachments: [],
  },
  {
    title: "News Title",
    description: "News Description",
    date: "DD-MM-YYYY",
    attachments: [],
  },
];

const News = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Fetch Notice Board Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const newsData = await getHighlight();

        console.log("Notice Data:", newsData);

        setData(newsData || []);
      } catch (error) {
        console.error("Error fetching notice data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Format Date
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  // React Slick Settings
  const settings = {
    dots: false,
    arrows: false,

    // Infinite loop
    infinite: true,

    // Smooth marquee movement
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",

    // Show 3 notices
    slidesToShow: 3,
    slidesToScroll: 1,

    // Vertical marquee
    vertical: true,
    verticalSwiping: true,

    // Stop when mouse is over slider
    pauseOnHover: true,

    // Responsive
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="notice-board-sec">
      {/* ================= HEADER ================= */}
      <div className="notice-board-head">
        <h3>
          <i className="bi bi-bell"></i>
          NOTICE BOARD
        </h3>

        <button className="notice-arrow-btn">
          <i className="bi bi-arrow-up-right"></i>
        </button>
      </div>

      {/* ================= NOTICE LIST ================= */}
      <div className="notice-list">
        {/* Loading */}
        {loading && <div className="notice-loading">Loading...</div>}

        {/* Notices */}
        {!loading && data.length > 0 && (
          <Slider {...settings}>
            {data.map((item, index) => (
              <div className="notice-slide" key={item.id || item._id || index}>
                <div className="notice-item">
                  {/* Left Arrow */}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/left-arrow.png"
                    alt=""
                    className="notice-left-arrow"
                  />

                  {/* Content */}
                  <div className="notice-content">
                    <p>
                      {item.title ||
                        item.description ||
                        item.highlight ||
                        item.notice ||
                        "Notice available"}
                    </p>

                    {/* Date */}
                    <span>
                      <i className="bi bi-calendar"></i>

                      {formatDate(item.fromDate)}
                    </span>
                  </div>

                  {/* Attachment */}
                  {item.attachments && item.attachments.length > 0 && (
                    <a
                      href={item.attachments[0]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="notice-file-btn"
                    >
                      <i className="bi bi-paperclip rotate-90"></i>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </Slider>
        )}

        {/* No Data */}
        {!loading && data.length === 0 && (
          <div className="notice-no-data">
            {DUMMY_DATA.map((item) => {
              return (
                <>
                  <div className="notice-slide">
                    <div className="notice-item" key={item.id}>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/DEMO3/public/Images/left-arrow.png"
                        alt=""
                        className="notice-left-arrow"
                      />
                      <div className="notice-content">
                        <p>{item.title}</p>

                        {/* Date */}
                        <span>
                          <i className="bi bi-calendar"></i>

                          {item.date}
                        </span>
                      </div>

                      {/* Attachment */}

                      <a
                        href={item.attachments[0]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="notice-file-btn"
                      >
                        <i className="bi bi-paperclip rotate-90"></i>
                      </a>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default News;
